import { COLORS } from '../Color';
import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import Pagination from '../../components/pagination/Pagination';
import BoardService from '../../../service/board/Board';
import { useLocation } from 'react-router-dom';
import NoticeList from '../../components/board/NoticeList';

const TABS = ['공지사항', 'FAQ'];
const SUB_TABS: Record<string, string[]> = {
  공지사항: ['전체', '공지사항', '업데이트'],
  FAQ: ['회원정보', '결제', '서비스 이용', '기타'],
};

type BoardListProps = {
  setBoardType: (type: string) => void;
  setArticleidx: (articleidx: number) => void;
};

const BoardList = () => {
  const location = useLocation();
  const { articleId, boardType } = (location.state as any) || '';

  const [list, setList] = useState<any[]>([]);
  const [offset, setOffset] = useState<number>(0);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const totalPages = Math.ceil(totalCount / 10);
  const [activeTab, setActiveTab] = useState('공지사항');
  const [activeSubTab, setActiveSubTab] = useState(SUB_TABS['공지사항'][0]);

  const limit = 10;

  const getCategoryByTab = () => {
    if (activeTab === '공지사항') {
      switch (activeSubTab) {
        case '전체':
          return 'A';
        case '공지사항':
          return 'B';
        case '업데이트':
          return 'C';
        default:
          return 'A';
      }
    }

    return;
  };

  const getList = async () => {
    try {
      const category = getCategoryByTab();
      let res;
      if (activeTab === '공지사항') {
        res = await BoardService.articlList(category, limit, offset);
        setTotalCount(res.data.totalCount);
        setList(res.data.list);
      } else {
        setTotalCount(0);
        setList([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getList();
  }, [activeTab, activeSubTab, limit, offset]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setOffset((page - 1) * limit);
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column' as 'column',
      }}
    >
      <TabBox>
        {TABS.map((tabName) => (
          <TabButton
            key={tabName}
            isActive={activeTab === tabName}
            onClick={() => {
              if (tabName === 'FAQ') {
                window.open(
                  'https://transfarmer.notion.site/zipgo-auction-faq',
                  '_blank',
                );
              } else {
                setActiveTab(tabName);
                setActiveSubTab(SUB_TABS[tabName][0]);
              }
            }}
          >
            {tabName}
          </TabButton>
        ))}
      </TabBox>
      <SubTabBox>
        {SUB_TABS[activeTab].map((subTab) => (
          <SubTabButton
            key={subTab}
            isActive={activeSubTab === subTab}
            onClick={() => setActiveSubTab(subTab)}
          >
            {subTab}
          </SubTabButton>
        ))}
      </SubTabBox>
      <div style={styles.section3}>
        <div style={styles.tableContainer}>
          <div style={styles.table}>
            {list && list.length === 0 && (
              <span style={styles.emptyMessage}>작성된 게시물이 없습니다.</span>
            )}
            <div style={styles.tableList}>
              {list.map((data, index) => {
                return <NoticeList data={data} index={index} />;
              })}
            </div>
          </div>
        </div>
      </div>
      {list.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};
export default BoardList;

const styles = {
  section2: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: 24,
    width: '100%',
    paddingInline: '16px',
    paddingTop: '24px',
  },
  section3: {
    display: 'flex',
    flexDirection: 'column' as 'column',
  },
  section3header: {
    paddingTop: '32px',
    paddingBottom: '13px',
    paddingInline: '16px',
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'space-between',
  },
  section3headerText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '29px',
  },

  tableContainer: {
    display: 'flex',
    //paddingInline: '16px',
  },
  table: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    width: '100%',
    flex: 1,
  },
  tableRow: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'row' as 'row',
    backgroundColor: '#F7F8F9',
    width: '100%',
    marginBottom: '8px',
  },
  tableList: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as 'column',
  },
  tableListRow: {
    display: 'flex',
    flexDirection: 'column' as 'row',
    backgroundColor: '#F7F8F9',
    width: '100%',
    borderBottom: '1px solid #171E261A',
    borderBottomColor: '#171E261A',
    padding: '16px 24px',
    gap: '8px',
  },
  tableCol: {
    display: 'flex',
    flexWrap: 'wrap' as 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableheaderText: {
    width: 'fit-content',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '18.85px',
    color: '#222222',
    textAlign: 'center' as 'center',
  },
  listRowText: {
    width: '100%',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '18.85px',
    color: '#171E268F',
    textAlign: 'center' as 'center',
  },
  dropdown: {
    minWidth: '109px',
    borderColor: COLORS.primary,
    border: '1px solid ' + COLORS.primary,
    borderRadius: 8,
    paddingBlock: '8px',
    paddingInline: '16px',
    backgroundColor: '#FFFFFF',
  },
  selectText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '23.2px',
  },
  searchBox: {
    width: '720px',
    border: '1px solid #171E26',
    borderColor: '#171E26',
    borderRadius: 8,
    paddingBlock: '12px',
    paddingInline: '16px',
    display: 'flex',
    flexDirection: 'row' as 'row',
  },
  input: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '23.2px',
    textAlign: 'left' as 'left',
    width: '100%',
  },
  inputBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: 4,
  },
  section04: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    gap: 40,
    paddingTop: '16px',
    paddingInline: '16px',
  },
  writeBtn: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    border: '1px solid ' + COLORS.primary,
    borderColor: COLORS.primary,
    borderRadius: 8,
    width: '77px',
    height: '35px',
  },
  btnText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '18.85px',
    color: COLORS.primary,
  },
  emptyMessage: {
    width: '100%',
    height: '200px',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '18.85px',
    color: COLORS.disabled,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

const TabBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e1e4e8;
  padding-inline: 16px;
  position: sticky;
  top: 56px;
  background-color: #ffffff;
`;

interface TabButtonProps {
  isActive: boolean;
}

const TabButton = styled.div<TabButtonProps>`
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 500;
  color: ${(props: TabButtonProps) => (props.isActive ? '#222222' : '#989BA2')};
  cursor: pointer;
  border-bottom: ${(props: TabButtonProps) =>
    props.isActive ? '2px solid #222222' : 'none'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50%;
`;

const SubTabBox = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #616161;
  position: sticky;
  top: 99px;
  background-color: #ffffff;
`;

interface SubTabButtonProps {
  isActive: boolean;
}

const SubTabButton = styled.div<SubTabButtonProps>`
  font-size: 15px;
  padding: 7px 12px;
  font-weight: 500;
  border-radius: 9999px;
  background-color: ${(props: SubTabButtonProps) =>
    props.isActive ? '#222222' : '#F7F7F8'};
  color: ${(props: SubTabButtonProps) =>
    props.isActive ? '#FFFFFF' : '#616161'};
  cursor: pointer;
  margin-right: 10px;
`;
